/* HEADSTRONG "BRAIN FIRST" HOMEPAGE v1 (2026-09-11)
   Hero arena rotation, Same Clock scroll, formula finder, roster filter, throughline.
   Loaded (deferred) by every hs-bf-* section; the guard below makes repeat loads no-ops.
   Re-initialises on shopify:section:load so the theme editor stays live.

   UPDATE 2026-09-13: BUMP stayed the stimulant-free powder, so the finder no
   longer warns about pairing BUMP with FOCUS. STIM is empty and the note is
   skipped when empty. If a stimulant is ever added to BUMP, put the sentence
   back here and in: the stack builder (warn setting), the Stack and BUMP
   product pages, the homepage and Shop FAQs, and the popup (stim setting). */
(function () {
  if (window.__hsbf) return;
  window.__hsbf = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clocks = [];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readCfg(el) {
    var node = el.querySelector('[data-hsbf-cfg]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /* Height of a sticky/fixed header, so the Same Clock pins below it. */
  function topOffset() {
    var els = document.querySelectorAll('.shopify-section-header-sticky, sticky-header, .section-header, .shopify-section-group-header-group');
    for (var i = 0; i < els.length; i++) {
      var cs = getComputedStyle(els[i]);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = els[i].getBoundingClientRect();
        if (r.top <= 1 && r.bottom > 0) return Math.round(r.bottom);
      }
    }
    return 0;
  }

  /* ---------- Hero ---------- */
  function initHero(el) {
    if (el.getAttribute('data-ready')) return;
    el.setAttribute('data-ready', '1');
    var words = [];
    try { words = JSON.parse(el.getAttribute('data-words') || '[]'); } catch (e) {}
    var word = el.querySelector('[data-hsbf-word]');
    var figs = el.querySelectorAll('.hsbf-frame__fig');
    var ticks = el.querySelectorAll('.hsbf-ticks span');
    var n = Math.max(words.length, figs.length);
    if (n < 2 || reduce) return;
    var ms = parseInt(el.getAttribute('data-interval'), 10) || 3200;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % n;
      var next = words[i];
      if (word && next) {
        word.classList.add('is-out');
        setTimeout(function () {
          word.textContent = next;
          word.classList.remove('is-out');
          word.classList.add('is-pre');
          void word.offsetWidth;
          word.classList.remove('is-pre');
        }, 420);
      }
      for (var k = 0; k < figs.length; k++) figs[k].classList.toggle('is-on', k === i);
      for (var t = 0; t < ticks.length; t++) ticks[t].classList.toggle('is-on', t <= i);
    }, ms);
  }

  /* ---------- Same Clock ---------- */
  function hex(h) {
    h = String(h || '#000000').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    return [0, 2, 4].map(function (j) { return parseInt(h.substr(j, 2), 16) || 0; });
  }
  function seg(p, keys) {
    for (var i = 1; i < keys.length; i++) {
      if (p <= keys[i][0]) return [i, (p - keys[i - 1][0]) / ((keys[i][0] - keys[i - 1][0]) || 1)];
    }
    return [keys.length - 1, 1];
  }
  function initClock(el) {
    if (el.getAttribute('data-ready')) return;
    var cfg = readCfg(el);
    if (!cfg || !cfg.phases || !cfg.phases.length) return;
    el.setAttribute('data-ready', '1');
    var ph = cfg.phases;
    var c = ph.map(function (p) { return p.color; });
    while (c.length < 3) c.push(c[c.length - 1]);
    clocks.push({
      el: el,
      ph: ph,
      cur: -1,
      KT: [[0, 360], [0.25, 450], [0.42, 840], [0.58, 900], [0.75, 1320], [1, 1350]],
      KC: [[0, c[0]], [0.25, c[0]], [0.42, c[1]], [0.58, c[1]], [0.75, c[2]], [1, c[2]]],
      sticky: el.querySelector('.hsbf-clock__sticky'),
      bg: el.querySelector('.hsbf-clock__bg'),
      time: el.querySelector('[data-hsbf-time]'),
      tag: el.querySelector('[data-hsbf-ptag]'),
      line: el.querySelector('[data-hsbf-pline]'),
      whats: el.querySelectorAll('[data-hsbf-what]'),
      bottle: el.querySelector('[data-hsbf-bottle]'),
      rail: el.querySelector('.hsbf-clock__rail')
    });
  }
  function setPhase(st, n) {
    st.cur = n;
    var d = st.ph[n];
    for (var i = 0; i < st.whats.length; i++) st.whats[i].style.opacity = 0;
    if (st.bottle) st.bottle.style.opacity = 0;
    setTimeout(function () {
      for (var i = 0; i < st.whats.length; i++) {
        st.whats[i].textContent = (d.rows && d.rows[i]) || '';
        st.whats[i].style.opacity = 1;
      }
      if (st.tag) {
        st.tag.textContent = d.name;
        st.tag.style.setProperty('--c', d.color);
        st.tag.style.setProperty('--ci', d.ink);
      }
      if (st.line) st.line.textContent = d.line;
      if (st.bottle && d.img) {
        st.bottle.src = d.img;
        st.bottle.alt = 'Headstrong ' + d.name;
        st.bottle.style.opacity = 1;
      }
    }, reduce ? 0 : 180);
  }
  function tickClocks() {
    if (!clocks.length) return;
    var top = topOffset();
    clocks.forEach(function (st) {
      if (!document.body.contains(st.el)) return;
      st.sticky.style.top = top + 'px';
      st.sticky.style.height = 'calc(100vh - ' + top + 'px)';
      var r = st.el.getBoundingClientRect();
      var total = st.el.offsetHeight - (window.innerHeight - top);
      var p = total > 0 ? Math.min(1, Math.max(0, (top - r.top) / total)) : 0;
      var s = seg(p, st.KT);
      var m = st.KT[s[0] - 1][1] + (st.KT[s[0]][1] - st.KT[s[0] - 1][1]) * s[1];
      m = Math.round(m / 5) * 5;
      if (st.time) st.time.textContent = String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
      var s2 = seg(p, st.KC);
      var a = hex(st.KC[s2[0] - 1][1]);
      var b = hex(st.KC[s2[0]][1]);
      if (st.bg) st.bg.style.backgroundColor = 'rgb(' + a.map(function (v, j) { return Math.round(v + (b[j] - v) * s2[1]); }).join(',') + ')';
      if (st.rail) st.rail.style.setProperty('--p', p);
      var n = p < 0.335 ? 0 : (p < 0.665 ? 1 : 2);
      n = Math.min(n, st.ph.length - 1);
      if (n !== st.cur) setPhase(st, n);
    });
  }

  /* ---------- Finder ---------- */
  var Q = [
    { q: 'Where do you perform?', o: [['Sport', 'Practice, games, travel', 'sport'], ['Business', 'Founders, leaders, deal days', 'biz'], ['School', 'Lectures, labs, exams', 'school'], ['Work and home', 'The job, then the second shift', 'home']] },
    { q: 'When does your edge slip?', o: [['First thing', 'Slow to get going', 'am'], ['The afternoon wall', 'Focus fades after lunch', 'pm'], ['The big moment', 'When the stakes are highest', 'big'], ['Switching off', 'Hard to wind down at night', 'night']] },
    { q: 'What do you want most?', o: [['Sharp, every day', 'A daily baseline', 'bump'], ['Locked in on demand', 'For the moments that count', 'focus'], ['Better nights', 'Recovery that starts at bedtime', 'sleep'], ['All of it', 'Morning, moment and night', 'stack']] }
  ];
  var ARENA = { sport: 'game day', biz: 'launch day', school: 'finals week', home: 'the second shift' };
  var SLIP = { am: ['bump', 'first thing'], pm: ['focus', 'the afternoon wall'], big: ['focus', 'the big moment'], night: ['sleep', 'bedtime'] };
  var STIM = '';

  function initFinder(el) {
    if (el.getAttribute('data-ready')) return;
    var cfg = readCfg(el);
    var box = el.querySelector('[data-hsbf-quiz]');
    if (!cfg || !box) return;
    el.setAttribute('data-ready', '1');
    var F = cfg.formulas || {};
    var ans = [];

    function packImg(k, cls) {
      var f = F[k];
      return f && f.img ? '<img class="hsbf-pack' + (cls || '') + '" src="' + esc(f.img) + '" alt="' + esc('Headstrong ' + f.name) + '" loading="lazy">' : '';
    }
    function renderQ() {
      if (ans.length === 3) return renderResult();
      var d = Q[ans.length];
      var h = '<p class="hsbf-quiz__step">' + (ans.length + 1) + ' of 3</p><h3>' + esc(d.q) + '</h3><div class="hsbf-quiz__opts">';
      d.o.forEach(function (o) {
        h += '<button type="button" class="hsbf-quiz__opt" data-v="' + o[2] + '">' + esc(o[0]) + '<small>' + esc(o[1]) + '</small></button>';
      });
      h += '</div>';
      if (ans.length) h += '<button type="button" class="hsbf-quiz__back" data-back>Back</button>';
      box.innerHTML = h;
      box.querySelectorAll('[data-v]').forEach(function (b) {
        b.addEventListener('click', function () { ans.push(b.getAttribute('data-v')); renderQ(); focusBox(); });
      });
      var back = box.querySelector('[data-back]');
      if (back) back.addEventListener('click', function () { ans.pop(); renderQ(); focusBox(); });
    }
    function renderResult() {
      var a = ans[0], s = ans[1], w = ans[2];
      var arena = ARENA[a] || 'your day';
      var stage, title, body, cta, url, note = '';
      if (w === 'stack' || !F[w]) {
        stage = '<div class="hsbf-result__stage hsbf-result__stage--trio" style="--c:#2d2d2d">' + packImg('bump') + packImg('focus') + packImg('sleep') + '</div>';
        title = (cfg.stack && cfg.stack.title) || 'The Daily Brain Stack';
        body = (F.bump ? F.bump.name : 'BUMP') + ' in the morning, ' + (F.focus ? F.focus.name : 'FOCUS') + ' when it counts, ' + (F.sleep ? F.sleep.name : 'SLEEP') + ' at night. Built for ' + arena + ', and every day around it.';
        cta = 'Shop the stack';
        url = (cfg.stack && cfg.stack.url) || '#';
        note = STIM;
      } else {
        var f = F[w], pair = SLIP[s];
        stage = '<div class="hsbf-result__stage" style="--c:' + esc(f.color) + '">' + packImg(w) + '</div>';
        title = f.full || ('Headstrong ' + f.name);
        body = f.job + ' ' + f.when + ' Built for ' + arena + '.';
        if (pair && pair[0] !== w && F[pair[0]]) {
          body += ' Your edge slips at ' + pair[1] + ', so pair it with ' + (F[pair[0]].full || F[pair[0]].name) + '.';
        }
      }
      box.innerHTML = '<div class="hsbf-result">' + stage + '<div><p class="hsbf-quiz__step">Your formula</p><h4>' + esc(title) + '</h4><p>' + esc(body) + '</p>' +
        '<div class="hsbf-ctas"><a class="hs-u-btn hs-u-btn--buy-inv" href="' + esc(url) + '">' + esc(cta) + '</a>' +
        '<button type="button" class="hsbf-quiz__back" data-reset style="margin-top:0">Start over</button></div>' +
        (note ? '<p class="hsbf-result__note">' + esc(note) + '</p>' : '') + '</div></div>';
      box.querySelector('[data-reset]').addEventListener('click', function () { ans = []; renderQ(); focusBox(); });
    }
    function focusBox() {
      var first = box.querySelector('button, a');
      if (first) first.focus({ preventScroll: true });
    }
    renderQ();
  }

  /* ---------- Roster filter ---------- */
  function initRoster(el) {
    if (el.getAttribute('data-ready')) return;
    el.setAttribute('data-ready', '1');
    var btns = el.querySelectorAll('[data-hsbf-f]');
    var tiles = el.querySelectorAll('[data-hsbf-sport]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-hsbf-f');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        tiles.forEach(function (t) { t.hidden = !(f === 'all' || t.getAttribute('data-hsbf-sport') === f); });
      });
    });
  }

  /* ---------- Throughline ---------- */
  function tickThru() {
    var t = document.querySelector('.hsbf-thru');
    if (!t) return;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    t.style.setProperty('--p', max > 0 ? window.scrollY / max : 0);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { tickClocks(); tickThru(); ticking = false; });
  }
  function initAll() {
    document.querySelectorAll('[data-hsbf-hero]').forEach(initHero);
    document.querySelectorAll('[data-hsbf-clock]').forEach(initClock);
    document.querySelectorAll('[data-hsbf-finder]').forEach(initFinder);
    document.querySelectorAll('[data-hsbf-roster]').forEach(initRoster);
    onScroll();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function () {
    clocks = clocks.filter(function (s) { return document.body.contains(s.el); });
    initAll();
  });
})();
